<template>
  <div class="p-grid p-fluid">
    <div class="p-col-12" style="border-bottom: 2px solid black">
      {{ translate("saved.display.profiles") }}
    </div>
    <div
        class="p-col-12"
        style="min-height: 555px; padding: 0px; max-width: 100%"
    >
      <DataTable
          :scrollable="true"
          :selection.sync="gridProfileSelection"
          :value="getProfiles"
          class="profile-table"
          dataKey="id"
          scroll-height="500px"
          selectionMode="single"
          style="max-width: 100% !important"
      >
        <Column>
          <template #body="slotProps">
            <div class="centered-left">
              <template v-if="isProfileActive(slotProps.data)">
                <b><i>{{ slotProps.data.profileName }}</i></b>
              </template>
              <template v-else>
                {{ slotProps.data.profileName }}
              </template>
              <i v-if="slotProps.data.published" class="pi pi-users"></i>
              <i v-if="slotProps.data.defaultProfile" class="pi pi-heart"></i>
            </div>
            <div class="centered-right">
              <Button
                  class="p-button-secondary"
                  icon="pi pi-angle-down"
                  v-on:click="searchProfileClick(slotProps.data, $event)"
              ></Button>
            </div>
          </template>
        </Column>
      </DataTable>
    </div>
    <ContextMenu ref="menu" :model="authorizedItems" :visible="true"></ContextMenu>
    <div class="p-col-12">
      <Button
          :disabled="gridProfileSelection == null"
          :label="translate('button.load.profile')"
          v-on:click="loadProfileClick"
      ></Button>
      <Button
          :label="translate('button.new.profile')"
          style="margin-top: 6px"
          @click="createNewProfile"
      />
      <PickListTest></PickListTest>
    </div>
    <Dialog
        :header="translate('header.delete.confirmation')"
        :modal="true"
        :style="{ width: '50vw' }"
        :visible.sync="deleteDialog"
    >
      {{ translate("would.you.delete.the.profile") }}
      <span v-if="clickedProfile != null">
        {{ clickedProfile.profileName }}</span
      >
      <template #footer>
        <Button
            :label="translate('button.delete')"
            class="p-button-danger"
            icon="pi pi-trash"
            @click="deleteConfirmation"
        />
        <Button
            :label="translate('button.cancel')"
            class="p-button-secondary"
            icon="pi pi-times"
            @click="deleteDialog = false"
        />
      </template>
    </Dialog>
  </div>
</template>
<script>
import PickListTest from "../layout/PickListTest";
import {mapActions, mapGetters} from "vuex";
import TranslateService from "../services/translate.service";
import _ from 'lodash';

export default {
  name: "SavedProfiles",
  components: {PickListTest},
  data() {
    return {
      deleteDialog: false,
      clickedProfile: null,
      currentId: null,
      displayBasic: false,
      gridProfileSelection: null,
      items: [
        {
          label: "Publish",
          icon: "pi pi-users",
          command: () => {
            this.publishClick();
          },
          needAuthorization: true,
        },
        {
          label: "Depublish",
          icon: "pi pi-user",
          command: () => {
            this.dePublishClick();
          },
          needAuthorization: true,
        },
        {
          label: "Set default",
          icon: "pi pi-heart",
          command: () => {
            this.setDefaultClick();
          },
          needAuthorization: false,
          // visible: !isDefault(),
        },
        {
          separator: true,
        },
        {
          label: "Edit",
          icon: "pi pi-pencil",
          command: () => {
            this.editProfile();
          },
          needAuthorization: true,
        },
        {
          label: "Delete",
          icon: "pi pi-trash",
          command: () => {
            this.deleteDialog = true;
          },
          needAuthorization: true,
        },
      ],
    };
  },
  computed: {
    ...mapGetters("profiles", ["getProfiles", "getActiveProfile"]),
    ...mapGetters('config', ['isAdmin']),

    isDefault() {
      if (this.clickedProfile === null) {
        return false;
      } else {
        return _.get(this.clickedProfile, "default", false);
      }
    },
    authorizedItems() {
      let items = _.cloneDeep(this.items);

      _.forEach(items, (item) => {
        _.set(item, "disabled", (item.needAuthorization && !(this.isAdmin || _.get(this.clickedProfile, "owner", false))));
      })

      return items;
    }

  },
  methods: {
    ...mapActions("profiles", [
      "showDialog",
      "loadGridProfiles",
      "deleteProfile",
      "loadCurrentProfile",
      "publishProfile",
      "dePublishProfile",
      "setActiveProfile",
      "setDefault"
    ]),
    translate(message) {
      return TranslateService.translateMessage(message);
    },
    loadProfileClick() {
      this.setActiveProfile(this.gridProfileSelection);
    },
    editProfile() {
      this.showDialog();
    },
    createNewProfile() {
      this.loadCurrentProfile(null);
      this.showDialog();
    },
    searchProfileClick(item, event) {
      this.clickedProfile = item;
      this.loadCurrentProfile(item);
      this.$refs.menu.show(event);
    },
    deleteConfirmation() {
      this.deleteProfile(this.clickedProfile.id);
      this.deleteDialog = false;
    },
    publishClick() {
      this.publishProfile(this.clickedProfile.id);
    },
    dePublishClick() {
      this.dePublishProfile(this.clickedProfile.id);
    },
    setDefaultClick() {
      this.setDefault(this.clickedProfile.id);
    },
    isProfileActive(profile) {
      if (this.getActiveProfile == null) {
        return false;
      }
      return this.getActiveProfile.id === profile.id;
    },
  },
  mounted() {
    this.loadGridProfiles();
  },
};
</script>

<style scoped>
.profile-table {
  width: 100% !important;
}
</style>
